import { useIntl } from 'platform-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CertificateModalContainer } from 'common.components/certificate-modal/certificate-modal.container';

import { teacherCertificateModalActions } from './actions';
import { getIsModalOpened } from './selectors';

export const TeacherCertificateModal = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const shouldShowModal = useSelector(getIsModalOpened);

    const closeModal = () => {
        dispatch(teacherCertificateModalActions.toogleModal({ shouldShowModal: false }));
    };

    if (!shouldShowModal) {
        return null;
    }

    return (
        //@ts-ignore
        <CertificateModalContainer
            canCancelSuggestion={false}
            closeModal={closeModal}
            imageData={{
                src: intl.formatMessage({ id: 'certificatesModal.image.certificate1x' }),
                srcSet: `${intl.formatMessage({ id: 'certificatesModal.image.certificate2x' })} 2x`,
            }}
            textData={{
                acceptButtonId: 'teacherCertificateModal.form.accept',
                titleId: 'teacherCertificateModal.header',
                descriptionId: 'teacherCertificateModal.description',
            }}
        />
    );
};
